import { cloneDeep } from 'lodash'
import qs from 'qs'
import { removeEmpty } from '~/mixins/objects'

const PAGE_SIZE = 20

const defaultState = {
  paginationParams: {
    number: 1,
    size: PAGE_SIZE
  },
  filters: {},
  loading: false,
  current: null,
  paginatedList: {
    list: [],
    pageCount: 0,
    totalCount: null
  }
}

export const state = () => cloneDeep(defaultState)

export const getters = {
  loading(state) {
    return state.loading
  },
  current(state) {
    return state.current
  },
  filters(state) {
    return state.filters
  },
  paginatedList(state) {
    return state.paginatedList
  },
  paginationParams(state) {
    return state.paginationParams
  }
}

export const mutations = {
  loading(state, loading) {
    state.loading = loading
  },
  current(state, current) {
    state.current = current
  },
  filters(state, filters) {
    state.filters = filters
  },
  list(state, list) {
    state.paginatedList.list = list
  },
  totalCount(state, totalCount) {
    state.paginatedList.totalCount = totalCount
  },
  pageCount(state, pageCount) {
    state.paginatedList.pageCount = pageCount
  },
  setCurrentPage(state, number) {
    state.paginationParams.number = number
  },
  setPageSize(state, size) {
    state.paginationParams.size = size
  }
}

export const actions = {
  async search({ state, commit }) {
    commit('loading', true)

    try {
      const response = await this.$coreApi.get('staff/venues', {
        params: {
          filter: removeEmpty(state.filters),
          page: state.paginationParams
        },
        paramsSerializer: params => qs.stringify(params)
      })

      commit('list', response.data.data)
      commit('totalCount', response.data.meta.recordCount)
      commit('pageCount', response.data.meta.pageCount)
    } finally {
      commit('loading', false)
    }
  },
  create(_, params) {
    // params already use the core's snake_case param names (see venue form). Do not run them
    // through lodash snakeCase, which would turn `address_line1` into `address_line_1`.
    return this.$coreApi.$post('staff/venues', removeEmpty(params))
  },
  update({ state }, params) {
    // Send params as-is (snake_case, nulls preserved): an explicit null means the staff cleared
    // a field (e.g. removed the map point or an address line) and the backend must receive it.
    return this.$coreApi.$put(`staff/venues/${state.current.id}`, params)
  },
  delete({ state }) {
    return this.$coreApi.$delete(`staff/venues/${state.current.id}`)
  }
}
